// removed by extract-text-webpack-plugin
module.exports = {"circleImageList":"_3rpsc2u","circleImageLink":"_3X9INkc","circleImageBorder":"tIg6Zov","circleImage":"CzRt8da","label":"_1dHc1LM","label__sale":"BLIJwya","label__bold":"_3wvpOZT"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css
// module id = ./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css
// module chunks = client.sitechrome